import React from 'react'
import { connect } from 'react-redux'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import {
  LocalForm,
  Control,
  actions
} from 'react-redux-form'

import {
  reset_tag
} from '../actions'

import {
  isRequired
} from "../validators"

const mapStateToProps = state => {
  return {
    mustRedirect: state.tag.must_redirect,
    current_user: state.auth.current_user.data
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // createSkill: (values) => dispatch( create_skill(values) ),
    // updateSkill: (id, values) => dispatch( update_skill(id, values) ),
    resetTag: () => dispatch( reset_tag() ),
  }
}

class ConnectedTagForm extends React.Component {
  state={
    nameValid: true,
    nameError: null,
    formValid: true
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  handleSubmit = (values) => {
    this.props.addTag(values)
    this.props.resetTag()
  }

  handleCancel = () => {
    this.props.resetTag()
    this.props.handleClose()
  }

  handleUpdate = (form) => {
    const {name, $form} = form
    const nameState = (name.pristine || name.valid)

    this.setState({
      nameValid: nameState,
      formValid: $form.valid
    })

  }

  componentDidUpdate(prevProps, prevState) {
    if ( this.props.mustRedirect !== prevProps.mustRedirect && this.props.mustRedirect === true) {
      this.handleCancel()
    }
  }

  render() {
    const {open, current_user} = this.props

    if ( !open || current_user.role !== "admin" ) {
      return ''
    }

    return (
        <Dialog
          open={open}
          aria-labelledby="tag-form"
          className="form-block"
        >
          <DialogTitle id="tag-form">Add new tag</DialogTitle>
          <DialogContent>
            <LocalForm
              model="tag"
              initialState={{name: ''}}
              getDispatch={(dispatch) => this.attachDispatch(dispatch)}
              onSubmit={this.handleSubmit}
              onUpdate={this.handleUpdate}
            >

              <Control
                id="tag-name"
                model="tag.name"
                margin="none"
                autoFocus
                fullWidth
                required
                FormHelperTextProps={{
                  classes: {
                    error: 'TextInput-error'
                  }
                }}
                placeholder="Name Of Tag"
                component={TextField}
                error={ !this.state.nameValid || this.props.tagError !== '' }
                helperText={this.state.nameValid ? ((this.props.tagError !== '') ? this.props.tagError : '') :  "Name is required" }
                validators={{
                  required: (val) => {
                    return isRequired(val)
                  }
                }}
              />

            </LocalForm>

          </DialogContent>
          <DialogActions>

            <Button className="c-blue buttonnoto" onClick={ e => {
              e.preventDefault()
              this.handleCancel()
            }} >
              CANCEL
            </Button>

            <Button
              label="Submit"
              aria-label="Submit"
              className="c-blue buttonnoto"
              onClick={e => {
                e.preventDefault()
                this.formDispatch( actions.submit('tag'))
              }}
              >
              OK
            </Button>

          </DialogActions>
        </Dialog>
    );
  }
}

const TagForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedTagForm);
export default TagForm



// WEBPACK FOOTER //
// ./src/js/components/TagForm.js